import scssConstants from './variables.module.scss';

export const styleConstants = {
    spaceAround: parseInt(scssConstants.spaceAround),
    headerMargin: parseInt(scssConstants.headerMargin),
    toolbarHeight: parseInt(scssConstants.toolbarHeight),
    legendHeight: parseInt(scssConstants.legendHeight),
    minLegendWidth: parseInt(scssConstants.minLegendWidth),
    minLegendEditingWidth: parseInt(scssConstants.minLegendEditingWidth),
};
